module.exports = __webpack_public_path__ + "img/visa.166b25bd.png";